<h3>{{ isFormEnabled ? "Enter Search Criteria" : "Search Criteria Review" }}</h3>
<div class="padding">
  <form [formGroup]="searchCriteriaDetails">
    @if (shouldDisplayExactSimilar) {
      <div class="flex-container">
        <div class="flex-item form-field">
          <mat-radio-group [formControlName]="'exactSimilar'" name="exact-similar"
            [attr.aria-label]="'orders.exactOrSimilarsRadioOption' | transloco">
            <mat-radio-button class="radio-button" [value]="false">{{ 'orders.includeSimilars' | transloco }}</mat-radio-button>
            <mat-radio-button class="radio-button" [value]="true">{{ 'orders.exactOnly' | transloco }}</mat-radio-button>
          </mat-radio-group>
        </div>
      </div>
    }

    <div class="flex-container">
      <div class="validated-form-field-container flex-container">
        <mat-form-field class="flex-item form-field" appearance="outline">
          <mat-label>{{ 'common.labels.serialNumber' | transloco }}</mat-label>
          <input matInput [formControlName]="'serialNumber'" name="serial-number" [placeholder]="'common.labels.serialNumber' | transloco">
        </mat-form-field>
        <lib-error-bubble [control]="searchCriteriaDetails.get('serialNumber')!"
        [message]="serialNumberError$"></lib-error-bubble>
      </div>
    </div>

    @if (shouldDisplaySearchFromDate) {
      <mat-expansion-panel
        [expanded]="shouldExpandAdditionalParameters()" (click)="this.hasUserExpandedAdditionalParameters = true"
        [class.mat-elevation-z1]="!panel.expanded" [class.mat-elevation-z0]="panel.expanded"
        #panel="matExpansionPanel">
        <mat-expansion-panel-header>
          <mat-panel-title>
            <h4>{{ 'orders.additionalParameters' | transloco }}</h4>
          </mat-panel-title>
        </mat-expansion-panel-header>
        @if (shouldDisplaySearchFromDate) {
          <div class="flex-container">
            <div class="validated-form-field-container flex-container">
              <mat-form-field class="form-field flex-item" appearance="outline">
                <mat-label>{{ 'orders.excludeRegistrationsPreviousTo' | transloco }}</mat-label>
                <input matInput [matDatepicker]="searchFromDate" [formControlName]="'searchFromDate'"
                  name="search-from-date" [placeholder]="'common.labels.yyyyMmDd' | transloco">
                <mat-datepicker-toggle matSuffix [for]="searchFromDate"></mat-datepicker-toggle>
                <mat-datepicker #searchFromDate></mat-datepicker>
              </mat-form-field>
              <lib-error-bubble [control]="searchCriteriaDetails.get('searchFromDate')!"
              [message]="searchFromDateError$"></lib-error-bubble>
            </div>
          </div>
        }
        <br />
        <br />
      </mat-expansion-panel>
    }
  </form>
</div>